/**
 * Chargement paresseux des gros jeux de données statiques.
 *
 * khassaides.json (~300 Ko) et mediatheque.json (~750 Ko) étaient importés
 * statiquement et gonflaient le bundle principal. On les charge désormais à
 * la demande (webpack crée des chunks séparés) avec un cache mémoire pour
 * éviter de recharger entre les pages.
 */

let khassaidesCache = null;
let mediathequeCache = null;

// Forme vide sûre : les tableaux référencés sans optional chaining dans la
// Médiathèque doivent exister pour éviter un crash pendant le chargement.
export const EMPTY_MEDIA = {
  sections: [],
  audio_archives: [],
  sample_tracks: [],
  coran_archives: [],
  wolofal_archives: [],
  xamxam_archives: [],
  kourel_archives: [],
  radiass_archives: []
};

export const loadKhassaides = async () => {
  if (!khassaidesCache) {
    khassaidesCache = (await import('../data/khassaides.json')).default;
  }
  return khassaidesCache;
};

export const loadMediatheque = async () => {
  if (!mediathequeCache) {
    mediathequeCache = (await import('../data/mediatheque.json')).default;
  }
  return mediathequeCache;
};
